import { useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { AddonReducers } from '@plone-collective/volto-editortemplates/types';
import config from '@plone/registry';
import type { AvailableBlocks } from '@plone/types';

interface AddonConfig {
  excludeBlocksFromTemplates: Array<AvailableBlocks>;
}

type AddonState = {
  [K in keyof AddonReducers]: ReturnType<AddonReducers[K]>;
};

type BlockIcon = {
  attributes: {
    xmlns: string;
    width: string;
    height: string;
    viewBox: string;
  };
  content: string;
  title: string;
};

const useTypedSelector: TypedUseSelectorHook<AddonState> = useSelector;

function getBlockIconAndName(key: string): BlockIcon | undefined {
  let blockIcon: BlockIcon;
  const blockConfig = config.blocks.blocksConfig;

  if (blockConfig.hasOwnProperty(key)) {
    const block = blockConfig[key];
    blockIcon = { ...block.icon, title: block.title };
  }
  return blockIcon;
}
function getBlockView(key: string) {
  return config.blocks.blocksConfig[key]?.view || null;
}

function getAllowedBlocks(allowedBlocks?: AvailableBlocks | undefined) {
  if (allowedBlocks) return allowedBlocks;
  const restrictedBlocks = (
    config.settings['volto-editor-templates'] as AddonConfig
  ).excludeBlocksFromTemplates;
  return Object.keys(config.blocks.blocksConfig).filter(
    (el: AvailableBlocks) => !restrictedBlocks.includes(el),
  );
}
export {
  useTypedSelector,
  getBlockIconAndName,
  getBlockView,
  getAllowedBlocks,
};
export type { AddonState };
